// theme.js
const breakpoints = ['800px', '1000px'];
const colors = {
  blue90: '#0D8CE6',
  blue30: '#C9E9FF',
  blue20: '#F4FAFE',
  blue10: '#ECF6FD',
  black100: '#000',
  gray90: '#525252',
  gray50: '#999999',
  purpleGray90: '#A0A2B2',
  gray20: '#E3E4E6',
  gray10: '#F1F1F1',
  red90: '#F04134',
  green90: '#2DC294',
  purple10: '#F5F6FA',
  orange90: '#F5A724',
  orange10: '#FFF6E7',
  white100: '#FFF',
};
const texts = {
  variants: {
    title: {
      color: colors.gray90,
      fontSize: '19px',
      fontWeight: 'bold',
    },
    subtitle: {
      color: colors.gray90,
      fontSize: '12px',
    },
    error: {
      color: colors.red90,
      fontSize: '12px',
      marginTop: '5px',
    },
  },
};

// aliases
breakpoints.sm = breakpoints[0];
breakpoints.md = breakpoints[1];
// breakpoints.lg = breakpoints[2]
// breakpoints.xl = breakpoints[3]

export default {
  breakpoints,
  colors,
  texts,
};
